// extracted by mini-css-extract-plugin
export default {"tbl":"Ranks_tbl__w1nQr"};